import { render, staticRenderFns } from "./DataTable5.vue?vue&type=template&id=d3133154&scoped=true"
import script from "./DataTable5.vue?vue&type=script&lang=js"
export * from "./DataTable5.vue?vue&type=script&lang=js"
import style0 from "./DataTable5.vue?vue&type=style&index=0&id=d3133154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3133154",
  null
  
)

export default component.exports